import { rest } from "msw";
import { randNumber,randBetweenDate, randUuid, } from '@ngneat/falso';
import dayjs from 'dayjs';
import {products} from '~@/mocks/data/product'

const getProducts = (pageSize:number)=>{
  return Array.from({length: pageSize},(_,index)=>{
    const product = products[randNumber({min: 0, max: products.length-1, fraction: 0})]
    return {
      image: product?.image,
      productName: product?.productName,
      stock: randNumber({min: 0, max: 200}),
      price: randNumber({min: 10, max: 120}).toLocaleString("zh-CN", {style: "currency", currency: "CNY"}),
      no: randUuid({length: 1}),
      updateAt: dayjs(randBetweenDate({ from: new Date('07/07/2023'), to: new Date() })).format("YYYY-MM-DD HH:mm:ss"),
    }
  })
}


const orderhandler = rest.get("/products", (req, res, ctx) => {
  const params = req.url.searchParams;
  const products = getProducts(Number(params.get("pageSize")))
  return res(
    ctx.status(200),
    ctx.json({
      data: {
        records: products,
        currentPage: Number(params.get("page")),
        pageSize: Number(params.get("pageSize")),
        totalPages: 1,
        totalSize: 10,
      },
      errorCode: 200,
      message: "",
    })
  );
});
export default orderhandler;
